import React, { useState } from "react";
import Widget from "../../../components/Widget/Widget";
import Datatable from "../../../components/Datatable/Datatable";
import { GetPermissions } from "../../../libs/permissions/getPermissions";
import { toast } from "react-toastify";
import Notification from "../../../components/Notification/Notification";
import ModalDelete from "../../../components/Modal/ModalDelete";
import { peticionesReceiver } from "../../../helpers/peticionesReceiver";
import Loader from "../../../components/Loader/Loader";
import { Button, Row, Collapse, Col } from "reactstrap";
import FormPercepcionesExtraordinarias from "./components/FormPercepcionesExtraordinarias";
import { fDate } from "../../../libs/tools/format";



const PercepcionesExtraordinarias = () => {
  const [permissions, setPermissions] = useState(true);
  const [loading, setLoading] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [collapse, setCollapse] = useState("home"); //detail, add, home
  const [perception, setPerception] = useState("");
  

  GetPermissions(setPermissions, setLoading);
  const API = peticionesReceiver();

  const headers = [
    "#",
    "Nombre de percepcion extraordinaria",
    "Concepto",
    "Fecha de inicio de aplicacion",
    "Fecha de fin de aplicacion",
    "Dias de pago",
    "Editar",
    "Eiminar",
  ];

  const columns = [
    { data: "index" },
    { data: "namePerceptionExtra" },
    { data: "nameUnder" },
    { data: "startDate" ,format: fDate },
    { data: "endDate" ,format: fDate },
    { data: "daysPay" },
    {
      data: null,
      render: function (row) {
        return permissions.UPD ?  (
          <td className="text-center d-flex justify-content-center">
            {
              permissions.UPD &&
              <i
                className={" fa fa-pencil text-warning handCursor"}
                onClick={() => {
                  changeView("add",row);
                }}
              />
            }
          </td>
        ) : (
          "Accion no permitida"
        );
      },
    },
    {
      data: null,
      render: function (row) {
        return permissions.DEL ? (
          <>
            <ModalDelete
              modalTitle="Eliminar"
              id={row.idSetup}
              table={["topics"]}
              nameColumn={["keyTopic"]}
              elimina={() => deletePerception(row)}
              setRefresh={setRefresh}
              type="icon"
            >
              <h6>¿Seguro de eliminar el registro?</h6>
              No podrá recuperar la información después de ser eliminada
            </ModalDelete>
          </>
        ) : (
          "Accion no permitida"
        );
      },
    },
  ];

  const deletePerception = async (perception) => {
    const params = {
      action: "delete",
      table: "perceptionsextras",
      condition: { idPerceptionExtra: perception.idPerceptionExtra },
    };
    await API.peticion(params)
      .then((res) => {
        if (res.data.status === "success" && res.data.code === "200") {
          toast(
            <Notification
              type={"elimina_exito"}
              backMessage={res.data.message}
              withIcon
            />
          );
          setRefresh(true);
        } else {
          toast(
            <Notification
              type={"elimina_error"}
              backMessage={res.data.message}
              withIcon
            />,
            { closeButton: false }
          );
        }
      })
      .catch((err) => {
        toast(<Notification type={"consultar_servidor_error"} withIcon />);
      });
  };

  const columnDefs = [
    {
      targets: [0, 1, 2, 3, 4, 5, 6],
      className: "text-center",
    },
    {
      orderable: false,
      targets: [0],
    },
  ];

  const getParamsTableElmt = (order, records, page, search) => {
    const params = {
      action: "datatable",
      table:
        "perceptionsextras A INNER JOIN unders B on (A.idUnder = B.idUnder)",
      rows: "A.idPerceptionExtra,A.idUnder,A.namePerceptionExtra,A.daysPay,A.startDate,A.endDate,B.nameUnder",
      conditions: `A.enabled = 1  `,
      order,
      records: records.toString(),
      page: (page * records).toString(),
      search,
    };
    return params;
  };

  async function getData(order, records, page, search) {
    try {
      const res = await API.peticion(
        getParamsTableElmt(order, records, page, search)
      );
      if (res.status === 200 && res.data.code === "200") {
        const data = res.data;

        data.data.forEach((value, index) => (value.index = 1 + index));
        return data;
      } else {
        toast(
          <Notification
            type={"consultar_error"}
            backMessage={res.data.message}
          />
        );
        return null;
      }
    } catch (err) {
      toast(<Notification type={"consultar_servidor_error"} withIcon />);
      return null;
    }
  }

  const changeView = (view, row) => {
    if (collapse !== "home") {
      setPerception("");
      setCollapse("home");
    } else {
      setPerception(row);
      setCollapse(view);
    }
  };
  const showDetail = (row) => {
    if (collapse !== "home") {
      setPerception("");
      setCollapse("home");
    } else {
      setPerception(row);
      setCollapse("detail");
    }
  };

  return (
    <Widget className="widget-p-md">
      {loading ? (
        <div className="text-center">
          <Loader />
        </div>
      ) : (
        <>
          {permissions.CON ? (
            <>
              {collapse === "home" && (
                <div className="text-center">
                  <h2>Percepciones extraordinarias</h2>
                </div>
              )}

              {
                permissions.INS &&
                <Row className="mb-3">
                  <Col className="text-right mb-3">
                    <Button
                      onClick={() => {
                        changeView("add");
                      }}
                      color={collapse === "home" ? "success" : "danger"}
                    >
                      {collapse === "home" ? "Agregar" : "Regresar"}
                    </Button>
                  </Col>
                </Row>
              }
              <Collapse isOpen={collapse === "home" ? true : false}>
                <div>
                  <Datatable
                    headers={headers}
                    columns={columns}
                    columnDefs={columnDefs}
                    petition={getData}
                    control="back"
                    stateRefresh={[refresh, setRefresh]}
                    searching={true}
                    order={{ col: 1, opt: "desc" }}
                  />
                </div>
              </Collapse>

              <Collapse isOpen={collapse === "add" ? true : false}>
                {collapse === "add" && (
                  <FormPercepcionesExtraordinarias
                    collapse={collapse}
                    setCollapse={setCollapse}
                    setRefreshP={setRefresh}
                    perception={perception}
                    setPerception={setPerception}
                    permissions={permissions}
                  />
                )}
              </Collapse>
              <Collapse isOpen={collapse === "detail" ? true : false}>
                {collapse === "detail" &&
                  {
                    /* <TicketDetail
                    collapse={collapse}
                    setCollapse={setCollapse}
                    setRefreshP={setRefresh}
                    ticket={ticketForEdit}
                    permissions={permissions}
                    idAreaLogged={idAreaLogged}
                  /> */
                  }}
              </Collapse>
            </>
          ) : (
            <div className="text-center">
              No tiene permisos de ver este modulo
            </div>
          )}
        </>
      )}
    </Widget>
  );
};

export default PercepcionesExtraordinarias;
